import { AppState, InstallationDetailsSelectors, RemoteConfigSelectors } from '@store';
import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { SmartHomeComponent } from '@vi-iot/client';
import { SmartHomeComponentsState } from './smart-home-components.state';

export namespace SmartHomeComponentsSelectors {
  export const smartHomeComponentsState = (state: AppState): SmartHomeComponentsState =>
    state.smartHomeComponents;

  export function getState(): MemoizedSelector<
    AppState,
    SmartHomeComponentsState,
    DefaultProjectorFn<SmartHomeComponentsState>
  > {
    return createSelector(smartHomeComponentsState, (state: SmartHomeComponentsState) => state);
  }

  export function getSmartHomeComponents(): MemoizedSelector<
    AppState,
    SmartHomeComponent[],
    DefaultProjectorFn<SmartHomeComponent[]>
  > {
    return createSelector(
      smartHomeComponentsState,
      (state: SmartHomeComponentsState) => state.smartHomeComponents
    );
  }

  export const isAllowedToSeeSmartHomeComponents = createSelector(
    RemoteConfigSelectors.isSmartHomeComponentsAvailable,
    RemoteConfigSelectors.selectCountriesWithSmartHomeComponent,
    InstallationDetailsSelectors.getInstallationAddressInfo,
    (isSmartHomeComponentsAvailable, availableCountries, installationAddress): boolean =>
      isSmartHomeComponentsAvailable &&
      availableCountries.some(
        (country) => country.toLowerCase() === installationAddress?.country?.toLowerCase()
      )
  );
}
